/**
 * The selection pill's shared parts, used by the canvas selection toolbar
 * and the Doc's formatting pill so both read as one control.
 */

/** The pill shape on the menu surface: its radius tokens, not `rounded-*`. */
export const SELECTION_PILL_RADIUS =
  "[--radius-surface-menu:var(--appkit-radius-pill)] [--denk-surface-radius-menu:var(--appkit-radius-pill)]";

export function PillDivider() {
  return <div className="mx-0.5 h-4 w-px bg-glass-stroke" aria-hidden="true" />;
}
